import { render } from "./ErrorDetailComponent.vue?vue&type=template&id=f37eae0e&scoped=true"
import script from "./ErrorDetailComponent.vue?vue&type=script&lang=js"
export * from "./ErrorDetailComponent.vue?vue&type=script&lang=js"

import "./ErrorDetailComponent.vue?vue&type=style&index=0&id=f37eae0e&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37eae0e"]])

export default __exports__